import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from '../../api/axios';

export const registerUser = createAsyncThunk('auth/registerUser', async ({ firstname, lastname, email, password, username, phone }, { rejectWithValue }) => {
  try {
    const { data } = await axios.post('/auth/register', {
      firstname,
      lastname,
      email,
      password,
      username,
      phone
    });
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Registration failed' });
  }
});

export const loginUser = createAsyncThunk("auth/loginUser", async ({ email, password }, { rejectWithValue }) => {
  try {
    const { data } = await axios.post('/auth/login', { email, password });
    
    // Store token and user info
    if (data.token) {
      localStorage.setItem('userToken', data.token);
      localStorage.setItem('currentUser', JSON.stringify(data.user));
    }
    
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Login failed' });
  }
});

export const getUserDetails = createAsyncThunk('user/getUserDetails', async (arg, { getState, rejectWithValue }) => {
  try {
    const currentUser = localStorage.getItem('currentUser');
    
    if (!currentUser) {
      return rejectWithValue({ message: 'Not authenticated' });
    }

    return JSON.parse(currentUser);
  } catch (err) {
    return rejectWithValue(err)
  }
});


export const updateUser = createAsyncThunk("auth/updateUser", async (userData, { getState, rejectWithValue }) => {
  try {
    const { auth } = getState();
    const { data } = await axios.put(`/auth/user/${auth.userInfo.id}`, userData);
    
    // Update local storage
    localStorage.setItem('currentUser', JSON.stringify(data.user));
    
    return data.user;
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Update failed' });
  }
});

// initialize userToken from local storage
const userToken = localStorage.getItem('userToken')
  ? localStorage.getItem('userToken')
  : null


const authSlice = createSlice({
  name: "auth",
  initialState: {
    error: false,
    loading: false,
    userInfo: null,
    userToken,
    success: false,
    errMsg: '',
    userErrorMsg: '',
    userUpdateError: false,
    userUpdateErrorMsg: '',
    editable: false,
    updating: false
  },
  reducers: {
    removeError: (state, { payload }) => {
      state.error = false
    },
    enableUpdate: (state, action) => {
      state.editable = !state.editable
    },
    cancelUpdate: (state, action) => {
      state.editable = false
    },
    logout: (state) => {
      localStorage.removeItem('userToken') // deletes token from storage
      localStorage.removeItem('currentUser')
      state.loading = false
      state.userInfo = null
      state.userToken = null
      state.error = null
    },
  },
  extraReducers: {
    [registerUser.pending]: (state) => {
      state.loading = true
      state.error = false
    },
    [registerUser.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.success = true
    },
    [registerUser.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errMsg = payload.message || 'Registration failed'
    },
    [loginUser.pending]: (state) => {
      state.loading = true
      state.error = false
    },
    [loginUser.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.userInfo = payload.user
      state.userToken = payload.token
      state.errMsg = ''
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.errMsg = payload.message || 'Login failed'
    },

    [getUserDetails.pending]: (state) => {
      state.loading = true
      state.error = false
    },
    [getUserDetails.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.userInfo = payload
      state.userErrorMsg = ''
    },
    [getUserDetails.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = true
      state.userErrorMsg = payload.message || 'Failed to get user details'
    },

    [updateUser.pending]: (state) => {
      state.updating = true
      state.userUpdateError = false
    },
    [updateUser.fulfilled]: (state, { payload }) => {
      state.updating = false
      state.userInfo = payload
      state.userUpdateErrorMsg = ''
      state.editable = false
    },
    [updateUser.rejected]: (state, { payload }) => {
      state.updating = false
      state.userUpdateError = true
      state.userUpdateErrorMsg = payload.message || 'Update failed'
      state.editable = false
    },
  }
})
export const { removeError, enableUpdate, cancelUpdate, logout } = authSlice.actions
export default authSlice.reducer
